import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Observable} from 'rxjs';
import { UtilService } from 'src/app/service/util';
import { PagamentoTitulo, PagamentoTituloLista } from 'src/app/interface/titulo';
import { IFiltroTitulo } from 'src/app/faturamento/filter/filtro-lista-titulo';


@Injectable({
  providedIn: 'root'
})
export class FinReceberService {

  constructor(
    private http: HttpClient,
    private utilService: UtilService) {
  }

  url = `${environment.urlApiProtheus}/wsrfinreceber`;

  listaTitulos(filtro: IFiltroTitulo): Observable<PagamentoTituloLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.http.get<PagamentoTituloLista>(`${this.url}/lista`, httpOptions);
  }

  getTitulo(filtro: IFiltroTitulo): Observable<PagamentoTitulo> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.http.get<PagamentoTitulo>(`${this.url}`, httpOptions);
  }

}
